const timerRu = {
  'time': {
    'hour': 'час',
    'min': 'мин',
    'sec': 'сек',
  },
};

export default timerRu;
